import script from "./NotificationDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationDetail.vue?vue&type=script&setup=true&lang=js"

import "./NotificationDetail.vue?vue&type=style&index=0&id=95eb7202&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95eb7202"]])

export default __exports__